// extracted by mini-css-extract-plugin
module.exports =  {"tabs":"sritCdpsAfioxd7qOyMq","placeholder":"TS9YuZh5DQQkYXLisVxH","body":"hqeNfT6FE_SOtvUpAgie"};